import { ButtonLoaderWrapper } from './styles'
import buttonLoader from 'assets/icons/buttonLoader.svg'
import Box from 'components/shared/Box'

const ButtonLoader = () => (
    <Box justify="center" hasNoShrink as="span">
        <ButtonLoaderWrapper src={buttonLoader} alt="loader" />
    </Box>
)

export default ButtonLoader
